/**
 * Inflected-language rule shared by move validation and the hint solver: a path may not
 * run through more than MAX_SAME_LEMMA_RUN consecutive forms of one lemma
 * (kuća → kući → kumi is fine, kuća → kuće → kući is not).
 *
 * Lemma groups come from the dictionary (WordGraph); languages without lemma data
 * (English) never trigger the rule.
 */
import { asGraph } from './wordGraph';
import { lowerWord } from './letters';

export const MAX_SAME_LEMMA_RUN = 2;

/** Comparable lemma key of a word; equal keys mean the same lemma. */
export function lemmaOf(dictionary, word) {
    if (!word) return null;
    const graph = asGraph(dictionary);
    return graph ? graph.lemmaKey(word) : lowerWord(word);
}

export function sameLemma(dictionary, a, b) {
    return lemmaOf(dictionary, a) === lemmaOf(dictionary, b);
}

/** True when `words` (in path order, nulls skipped) contain a same-lemma streak longer than allowed. */
export function lemmaRunTooLong(dictionary, words, maxRun = MAX_SAME_LEMMA_RUN) {
    let run = 0;
    let prev = null;
    for (const word of words) {
        if (!word) continue;
        const lemma = lemmaOf(dictionary, word);
        run = prev !== null && lemma === prev ? run + 1 : 1;
        prev = lemma;
        if (run > maxRun) return true;
    }
    return false;
}
